//デバイスの一覧を取得
async function getAvailableDevices() {
  const devices = await navigator.mediaDevices.enumerateDevices();
  const videoDevices = devices.filter((device) => device.kind === 'videoinput');
  const micDevices = devices.filter((device) => device.kind === 'audioinput');

  return [videoDevices, micDevices];
}

//メディアにリクエスト
async function GetMedia(
  mediaStream,
  cameraDeviceID,
  audioDeviceID,
  onlyCamera = false, //カメラのみデバイスが検出される場合
  onlyMic = false, //マイクのみデバイスが検出される場合
  webcamState, //ウェブカメラOn/Off
) {
  //初期値
  let stream; //ストリーム
  var videoDeviceID = 'default';
  var micDeviceID = 'default';
  var mediaError = false;
  var camCount = 0;
  var micCount = 0;

  //許可がある状態じゃないと値が帰ってこない
  const [videoDevices, micDevices] = await getAvailableDevices();

  //既存のメディアを一旦すべてストップする
  if (mediaStream.current != null) {
    let currentVideoTracks = mediaStream.current.getVideoTracks();
    currentVideoTracks.forEach((currentVideo) => {
      currentVideo.stop();
    });

    let currentAudioTracks = mediaStream.current.getAudioTracks();
    currentAudioTracks.forEach((currentAudio) => {
      currentAudio.stop();
    });
  }

  //カメラデバイスIDの取得
  if (videoDevices.length > 0) {
    videoDevices.forEach((videoDevice) => {
      //デバイス一覧に存在するかチェック
      if (videoDevice.deviceId == cameraDeviceID) {
        videoDeviceID = cameraDeviceID;
      } else if (videoDevice.deviceId == localStorage.getItem('cameraInput')) {
        videoDeviceID = localStorage.getItem('cameraInput');
      }
    });
  }

  //マイクデバイスIDの取得
  if (micDevices.length > 0) {
    micDevices.forEach((micDevice) => {
      if (micDevice.deviceId == audioDeviceID) {
        micDeviceID = audioDeviceID;
      }
      //デバイス一覧に存在するかチェック
      if (micDevice.deviceId == localStorage.getItem('micInput')) {
        micDeviceID = localStorage.getItem('micInput');
      }
    });
  }

  try {
    //ディフォルト（カメラとマイク両方）
    var constraint = {
      audio: {
        echoCancellation: true, //defaultはtrue
        sampleRate: { ideal: 32000 }, //defaultは48000
        deviceId: micDeviceID,
        //echoCancellationType: 'system', //Macの場合は最強らしい defaultは system
      },
      video: {
        facingMode: 'user',
        width: 400, //cameraWidth,
        height: 400, //cameraWidth,
        deviceId: videoDeviceID, //存在しないdeviceidを入れた場合は、自動的に一番候補をあてがってくれる
      },
    };

    //カメラのみの場合
    if (onlyCamera) {
      constraint = {
        audio: false,
        video: {
          facingMode: 'user',
          width: 400, //cameraWidth,
          height: 400, //cameraWidth,
          deviceId: videoDeviceID, //存在しないdeviceidを入れた場合は、自動的に一番候補をあてがってくれる
        },
      };
    }

    //マイクのみの場合
    if (onlyMic || webcamState == false) {
      constraint = {
        audio: {
          echoCancellation: true, //defaultはtrue
          sampleRate: { ideal: 32000 }, //defaultは48000
          deviceId: micDeviceID,
          //echoCancellationType: 'system', //Macの場合は最強らしい defaultは system
        },
        video: false,
      };
    }

    //ストリームにメディア情報を格納
    stream = await navigator.mediaDevices.getUserMedia(constraint);

    //カメラの確認
    const videoTracks = stream.getVideoTracks();
    camCount = videoTracks.length;

    //マイクの確認
    const audioTracks = stream.getAudioTracks();
    micCount = audioTracks.length;

    //エラー表示をオフ
    mediaError = false;
  } catch (e) {
    console.log(e);
    /**********
    許可されなかった場合、もしくはカメラが何もない場合
    カメラが何も接続されていないと、使用許可をもらってもエラーになるので、許可を受けている場合はカメラの数を取得
    **********/

    //現状取得可能なデバイス一覧
    const [videoDevices, micDevices] = await getAvailableDevices();

    //メディア許可が降りていない（またはなんのデバイスも見つからない)
    if (videoDevices.length < 1 && micDevices.length < 1) {
      mediaError = true;
    } else {
      //カメラのみある場合
      if (videoDevices.length > 0) {
        if (videoDevices[0].deviceId != '') {
          const newResult = await GetMedia(mediaStream, cameraDeviceID, audioDeviceID, true, false);
          return newResult;
        }
      }
      //マイクのみある場合
      if (micDevices.length > 0) {
        if (micDevices[0].deviceId != '') {
          const newResult = await GetMedia(mediaStream, cameraDeviceID, audioDeviceID, false, true);
          return newResult;
        }
      }

      //上記どれにも当てはまらない場合はエラー
      mediaError = true;
    }
  }
  return [stream, mediaError, camCount, micCount];
}
export default GetMedia;
